<div #dropdown class="ui fluid multiple search selection dropdown">
  <input name="tags" type="hidden" value="{{tags}}">
  <div class="default text">{{defaultText}}</div>
  <div class="menu"></div>
</div>